export enum ConditionOperator {
    AND = 'AND',
    OR = 'OR'
}

export enum JoinedEntity {
    USER = 'USER'
}
